import React from "react";
import { isEnterpriseLicense } from "license/helper/activeLicense";
import useActiveLicenseInformation from "license/hooks/useActiveLicenseInformation";
import { LICENSE_TYPE } from "license/constants";
import { TrafficGraphWithDaySelect } from "components/common/Graph";
import useClusterTraffic from "components/cluster/hooks/useClusterTraffic";
import useGraphDays from "components/common/Graph/contexts/useGraphDays";
const EnterpriseTrafficGraph = () => {
  const { graphDays } = useGraphDays();
  const { traffic } = useClusterTraffic(graphDays);
  const {
    data: activeLicenseData,
    isLoading: isLoadingActiveLicense,
    isError: isErrorActiveLicense
  } = useActiveLicenseInformation();
  const getTrafficLimit = () => {
    if (isLoadingActiveLicense || isErrorActiveLicense || !activeLicenseData) {
      return void 0;
    }
    if (!isEnterpriseLicense(activeLicenseData)) {
      return void 0;
    }
    if (activeLicenseData.license_type === LICENSE_TYPE.drawDown) {
      return void 0;
    }
    const {
      details: { traffic_limit: trafficLimit }
    } = activeLicenseData;
    return trafficLimit;
  };
  return /* @__PURE__ */ React.createElement(TrafficGraphWithDaySelect, { traffic: traffic == null ? void 0 : traffic.output, trafficLimit: getTrafficLimit() });
};
export default EnterpriseTrafficGraph;
